import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { formatMoney, num, plColor } from "./plConstants";

const HEADERS = ["Module", "Entries", "Agreed", "Cost", "Paid", "Due", "Profit / Loss"];

// Per-module aggregate; every module present in the filtered data appears here.
const ModuleBreakdown = ({ modules }) => {
  const rows = modules || [];

  const totals = rows.reduce(
    (acc, m) => ({
      entryCount: acc.entryCount + num(m.entryCount),
      agreedAmount: acc.agreedAmount + num(m.agreedAmount),
      cost: acc.cost + num(m.cost),
      paidAmount: acc.paidAmount + num(m.paidAmount),
      dueAmount: acc.dueAmount + num(m.dueAmount),
      profitLoss: acc.profitLoss + num(m.profitLoss),
    }),
    { entryCount: 0, agreedAmount: 0, cost: 0, paidAmount: 0, dueAmount: 0, profitLoss: 0 }
  );

  return (
    <Paper elevation={1} sx={{ p: 2, borderRadius: 2, height: "100%" }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
        Profit / Loss by Module
      </Typography>
      <TableContainer sx={{ maxHeight: 320 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {HEADERS.map((h, i) => (
                <TableCell key={h} align={i === 0 ? "left" : "right"} sx={{ fontWeight: 700 }}>
                  {h}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ color: "text.secondary" }}>
                  No data for the selected filters
                </TableCell>
              </TableRow>
            )}
            {rows.map((m) => (
              <TableRow key={m.module} hover>
                <TableCell>{m.module}</TableCell>
                <TableCell align="right">{num(m.entryCount)}</TableCell>
                <TableCell align="right">{formatMoney(m.agreedAmount)}</TableCell>
                <TableCell align="right">{formatMoney(m.cost)}</TableCell>
                <TableCell align="right">{formatMoney(m.paidAmount)}</TableCell>
                <TableCell align="right">{formatMoney(m.dueAmount)}</TableCell>
                <TableCell align="right">
                  <Box component="span" sx={{ color: plColor(m.profitLoss), fontWeight: 600 }}>
                    {formatMoney(m.profitLoss)}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
            {rows.length > 0 && (
              <TableRow sx={{ "& td": { fontWeight: 700, borderTop: "2px solid #eee" } }}>
                <TableCell>Total</TableCell>
                <TableCell align="right">{totals.entryCount}</TableCell>
                <TableCell align="right">{formatMoney(totals.agreedAmount)}</TableCell>
                <TableCell align="right">{formatMoney(totals.cost)}</TableCell>
                <TableCell align="right">{formatMoney(totals.paidAmount)}</TableCell>
                <TableCell align="right">{formatMoney(totals.dueAmount)}</TableCell>
                <TableCell align="right">
                  <Box component="span" sx={{ color: plColor(totals.profitLoss) }}>
                    {formatMoney(totals.profitLoss)}
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ModuleBreakdown;
